module.exports = __webpack_public_path__ + "img/c96.813241d3.png";